import { ReligionContext } from "./ReligionContext";
import { useContext } from "react";

export const useReligionContext = () => {
    const context = useContext(ReligionContext);
    if(!context){
        throw Error("useReligionContext should be used inside ReligionContextProvidor");
    }
    return context;
}